$(function () {

    // Add required flags to labels for validation. For complex forms do this manually.
    $("form.add-required-flags").find('input,textarea,select').each(function () {
        var req = $(this).attr('data-val-required');
        if (undefined != req) {
            var label = $('label[for="' + $(this).attr('id') + '"]');
            var text = label.text();
            if (text.length > 0) {
                label.append('<span class="req"> *</span>');
            }
        }
    });
   
    // Add character counter to text area where max length is set
    $("textarea[maxlength]").each(function () {
        var $textarea = $(this);
        var maxChars = parseInt($textarea.attr("maxlength"), 10);

        // Create and insert the counter element after the textarea, hidden by default
        var $counter = $('<div class="char-counter" aria-label="Characters remaining" style="display:none;"></div>');
        $textarea.after($counter);

        function updateCounter() {
            var length = $textarea.val().length;
            var remaining = maxChars - length;
            if (remaining < 0) remaining = 0;
            $counter.text(remaining + " / " + maxChars);

            // Show counter only if there is content
            if (length > 0) {
                $counter.show();
            } else {
                $counter.hide();
            }
        }

        $textarea.on("input", function () {
            // Enforce max length in case of paste
            if ($textarea.val().length > maxChars) {
                $textarea.val($textarea.val().substring(0, maxChars));
            }
            updateCounter();
        });

        // Initialize counter on page load
        updateCounter();
    });

});